import { formValueSelector } from 'redux-form';
import { isPrimaryFlow } from '../../common/utils/primaryFlow';
import { ProductCardLayoutType } from '../../common/models/product';
import { MEAL } from '../../products';
import { NO_OPTION } from './mealUtil';
const formSection = MEAL.name;
export const getLayoutType = (form, state) => {
  const layoutType = formValueSelector(form)(state, `${formSection}.layoutType`);
  return layoutType === ProductCardLayoutType.Small;
};
export const getMealState = (form, state) => {
  const isSmallCardEnabled = getLayoutType(form, state);
  return isSmallCardEnabled && isPrimaryFlow() ? Object.values(formValueSelector(form)(state, `${formSection}.travelers`) || {}).filter(traveler => traveler.selected).map(traveler => traveler.choice) : formValueSelector(form)(state, `${formSection}.dropdowns`);
};
export const isNoOption = value => value === NO_OPTION;
const getAllMealUnits = (form, state) => Object.values(getMealState(form, state) || {});
export const getNumberOfUnits = form => state => getAllMealUnits(form, state).reduce((totalUnits, {
  value
}) => isNoOption(value) ? totalUnits : totalUnits + 1, 0);
export const getSelected = form => state => getAllMealUnits(form, state).filter(unit => !isNoOption(unit.value));
//# sourceMappingURL=units.js.map